export default __webpack_public_path__ + "static/media/ic.b1468b6f.svg";